import { render } from "./Socials.vue?vue&type=template&id=42892242"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__